import { styled, Switch } from "@mui/material";

/**
 * Toggles Tokyo Night (off) and kawaii (on). The thumb carries an emoji rather
 * than an inlined SVG so the two themes announce themselves: a night skyline
 * for the calm one, a rainbow for the loud one.
 */
export const ThemeSwitch = styled(Switch)(({ theme }) => ({
  width: 46,
  height: 28,
  padding: 5,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(4px)",
    "&.Mui-checked": {
      transform: "translateX(18px)",
      "& .MuiSwitch-thumb": {
        backgroundColor: theme.palette.primary.main,
        boxShadow: `0 0 10px ${theme.palette.primary.main}`,
        "&:before": {
          content: '"🌈"',
        },
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.secondary.main,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.primary.main,
    width: 26,
    height: 26,
    "&::before": {
      content: '"🌃"',
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      fontSize: 14,
      lineHeight: "26px",
      textAlign: "center",
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.divider,
    borderRadius: 20 / 2,
  },
}));
